import React from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../components/Layout/layout";
import Integrations from "../../components/integrations";
import ProtectedRoute from "../../../Auth/components/ProtectedRoute";

const IntegrationsContainer = () => (
  <ProtectedRoute>
    <main>
    <Helmet title="Integrations" />
    <Layout>
      <Integrations />
    </Layout>
    </main>
  </ProtectedRoute>
);

export default IntegrationsContainer;
